import React, { useEffect, useState } from 'react';
import { useClient } from 'jsonapi-react';
import { TiaBanner } from '@/components/custom/tia-banner';
import { DashboardContent } from '@/layouts/dashboard';
import { PENSANDO } from '@/pages/dashboard/home-teacher/teacher-character';
import { INITIAL_FILTERS } from './filters';
import { QuestionsGateTeacher } from './QuestionsGateTeacher';
import { QuestionsListTeacher } from './QuestionsListTeacher';

export function QuestionsPlayfulTeacher({ uri }) {
  const client = useClient();
  const [taxonomies, setTaxonomies] = useState([]);
  const [phase, setPhase] = useState('gate');
  const [filters, setFilters] = useState(INITIAL_FILTERS);

  useEffect(() => {
    client
      .fetch('taxonomies/used_by_questions')
      .then(({ data }) => setTaxonomies(data || []))
      .catch(() => setTaxonomies([]));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const breadcrumbs = {
    title: 'Ferramentas de Avaliação',
    nav: [
      {
        route: uri,
        name: 'Questões',
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent
      variant="plain"
      breadcrumbs={breadcrumbs}
    >
      <TiaBanner
        className="mb-6 sm:mt-24"
        image={PENSANDO}
        imageAlt="Personagem do professor"
        imageHeight={215}
        imageOffset={200}
        bubbleCorner="tl"
        bubbleMaxWidth={420}
        text="Filtre para explorar as questões aprovadas do banco. A lista atualiza conforme você ajusta."
      />

      {phase === 'gate' ? (
        <QuestionsGateTeacher
          taxonomies={taxonomies}
          filters={filters}
          onFiltersChange={setFilters}
          onApply={() => setPhase('list')}
        />
      ) : (
        <QuestionsListTeacher
          filters={filters}
          onBack={() => setPhase('gate')}
        />
      )}
    </DashboardContent>
  );
}

export default QuestionsPlayfulTeacher;
